<app-header></app-header>
<a id="leftnav" class="vcal-btn"><span>Menu</span></a>
<app-leftsidebar></app-leftsidebar>
@if (params === 'details') {
  <div class="right-sec">
    <div class="sec-heading-1">
      <h2>{{ contentData?.modulename }}</h2>
      <button
        [routerLink]="['./']"
        [queryParams]="{ mode: 'edit', id: contentId, mapcode: mapCode }"
        class="btn btn-dark btn-sm d-md-inline-block"
        >
        Edit
      </button>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="pd-card mb-30">
          <div class="main-form-wrapper">
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center justify-content-start col-md-6 row"
                >
                <label class="col-md-6">Game System:</label>
                <p class="col-md-6">{{ contentData?.gamesystem }}</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-end col-md-6 row"
                >
                <label class="col-md-6">Type:</label>
                <p class="col-md-6">{{ contentData?.type }}</p>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center row justify-content-start col-md-6"
                >
                <label class="col-md-6">Name</label>
                <p class="col-md-6">{{ contentData?.gamesystem }}</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-end col-md-6 row"
                >
                <label class="col-md-6">Party Average:</label>
                <p class="col-md-6">{{ contentData?.partyaverage }}</p>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center justify-content-start col-md-6 row"
                >
                <label class="col-md-6">Recommend #Players:</label>
                <p class="col-md-6">{{ contentData?.recommend_player }}</p>
              </div>
              <div
                class="d-flex align-items-center justify-content-end col-md-6 row"
                >
                <label class="col-md-6">Cost:</label>
                <p class="col-md-6">{{ contentData?.cost }}</p>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center justify-content-start col-md-6 row"
                >
                <label class="col-md-6">Sold:</label>
                <p class="col-md-6">{{ contentData?.sold }}</p>
              </div>
              <div
                class="col-md-6 d-flex align-items-center justify-content-between plain-text"
                >
                <label class="col-md-6">Module Rating:</label>
                <label class="col-md-6">6/10</label>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center justify-content-start col-md-6 row"
                >
                <label class="col-md-6">Module Version:</label>
                <p class="col-md-6">{{ contentData?.moduleversion }}</p>
              </div>
              <div
                class="col-md-6 d-flex align-items-center justify-content-between plain-text"
                >
                <label class="col-md-6 col-sm-6">Difficulty Rating:</label>
                <label class="col-md-6 col-sm-6">8/10</label>
              </div>
            </div>
            <div class="row d-flex align-items-center justify-content-between">
              <div
                class="d-flex align-items-center row justify-content-start col-md-6"
                >
                <label class="col-md-6">Playtime (hrs):</label>
                <p class="col-md-6">{{ contentData?.playtime }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row d-flex align-items-center justify-content-around text-center p-15px"
      >
      <div class="col-md-12 col-lg-6 col-xl-6 align-self-stretch pl-0">
        <div class="ed-img">
          <img
            [src]="
              contentData
                ? contentData.gameimage
                  ? ip + contentData.gameimage
                  : 'assets/images/ed-img.png'
                : 'assets/images/ed-img.png'
            "
            alt=""
            />
          </div>
        </div>
        <div
          class="pd-card col-lg-6 col-md-12 col-sm-12 align-self-stretch mt-lg-0 mt-2"
          >
          <div class="pd-card-forth-col pd-card-one-col">
            <div><span>Terrain:</span> lorem ipsum lorem</div>
            <div><span>Biome:</span> lorem ipsum lorem</div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12 col-xl-12 pd-card mb-30 mt-30">
        <div class="desc">
          <h4>Descriptions:</h4>
          <p>{{ contentData?.description }}</p>
        </div>
      </div>
      <div class="col-md-12 row p-0 mx-auto">
        <div class="pd-card col-md-12">
          <h4>Map location</h4>
          <div class="map-wrapper">
            <div id="map" class="h-100"></div>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-5">
        <h3 class="font-60">Adventure asset samplers</h3>
        <div class="main-static-img-wrapper">
          <div class="row img-main-container">
            @for (item of contentData?.contentimagearr; track item) {
              <div
                class="col-md-6 mb-2 h-100"
                >
                <div class="inner-image-wrapper">
                  <img [src]="ip + item.file" alt="" class="h-100 w-100" />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-add-content
      [params]="params"
      [contentData]="contentData"
      [coordsRecieve]="coordsPass"
    ></app-add-content>
  }

  <app-footer></app-footer>
